export default "__VITE_ASSET__BLDXFoDi__"